import React from 'react';
import { SAppBar, SToolBar, SMburger } from './styles';
import IconButton from '@mui/material/IconButton';

const TopBar = ({ setOpenMenu }) => {

    return (<SAppBar position="fixed">
        <SToolBar variant="dense">
            <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} onClick={() => setOpenMenu(true)}>
                <SMburger />
            </IconButton>
        </SToolBar>
    </SAppBar>)
}

export default TopBar;